module.exports = function getResource(label) {
    const resources = { reviews: 'reviews' };
    return resources[label];
};
